<template>
  <div class="account-pages my-5 pt-sm-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <logo-header></logo-header>
        </div>
      </div>
      <!-- end row -->
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="card">
            <div class="card-body">
              <div class="p-2">
                <div class="text-center">
                  <loader :loading="loading" class="p-2 mt-4">
                    <div v-if="!verifyErr">

                      <div class="mb-4 avatar-md mx-auto">
                        <div class="avatar-title rounded-circle bg-light">
                          <i class="bx bx-mail-send h1 mb-0 text-primary"></i>
                        </div>
                      </div>

                      <h4>{{ $t('pages.confirm_email.success') }}</h4>
                      <p class="text-muted">
                        {{ $t('pages.confirm_email.success_message') }}
                      </p>
                      <div class="mt-4">
                        <b-btn @click="handleConfirm" variant="success">
                          <b-spinner small class="mx-1"/>
                          {{ $t('pages.confirm_email.start_earning') }}
                        </b-btn>
                      </div>
                    </div>

                    <div v-else>

                      <div class="mb-4 mx-auto">
                        <lottie :options="defaultOptions" :width="200"></lottie>
                      </div>

                      <h4>{{ $t('pages.confirm_email.fail') }}</h4>
                      <p class="text-muted">
                        {{ $t('pages.confirm_email.fail_message') }}
                      </p>

                      <p v-if="showError" class="text-danger">{{ $t('pages.confirm_email.too_many_request') }}</p>

                      <b-btn @click="resend" class="btn btn-success w-md mt-2"
                             :disabled="disabledResend"
                      >
                        <b-spinner v-if="resendLoading" small></b-spinner>
                        <i class="mdi mdi-arrow-right-circle me-1" v-else></i>
                        {{ $t('pages.confirm_email.resend') }}
                      </b-btn>
                    </div>
                  </loader>
                </div>
              </div>
            </div>
          </div>
          <login-footer></login-footer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AuthService from "../../../Services/Api/AuthService";
import LoginFooter from "./components/LoginFooter";
import loader from "../../../components/widgets/loader";
import LogoHeader from "../../../components/LogoHeader";
import verificationError from '@/assets/animations/verification-error.js'
import * as ls from 'local-storage'
import Lottie from "vue-lottie";

export default {
  page() {
    return {
      title: this.$t('pages.confirm_email.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  data() {
    return {
      loading: false,
      verifyErr: null,
      resendLoading: false,
      disabledResend: false,
      showError: false,
      defaultOptions: {animationData: verificationError, loop: true},
    };
  },
  components: {LogoHeader, LoginFooter, loader, Lottie},
  methods: {
    handleConfirm() {
      if (ls.get('selectedPlan')) {
        this.$router.push({name: 'pricing'})
        ls.remove('selectedPlan')
      } else {
        this.$router.push({name: 'dashboard'})
      }
    },
    async verify() {
      this.loading = true
      const parameters = {
        params: this.$route.params,
        query: this.$route.query
      }
      await AuthService.verify(parameters).then(() => {
        this.$auth.fetch()
        setTimeout(() => {
          this.handleConfirm()
        }, 1000)
      }).catch(err => {
        this.verifyErr = err.data.message
      }).finally(() => {
        this.loading = false
      })
    },
    async resend() {
      this.resendLoading = true
      this.disabledResend = true
      await AuthService.resendVerificationEmail().catch(() => {
        this.disabledResend = false
        this.showError = true
      }).finally(() => {
        this.resendLoading = false
      })
    }
  },
  created() {
    this.verify()
  }
};
</script>

